export enum LotDisplayModeEnum {
    SIMPLE = 1,
    DETAILED = 2,
}
